import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const formatText = (text?: string) =>
  text?.replace(/(?:\r\n|\r|\n)/g, '<br />');

interface MapLegendModalProps {
  legend: string;
  legendWarn: string;
  legendImage: React.Component;
  mainImageInLegend: React.Component;
  showHelpModal: boolean;
  toggleHelpModal: () => void;
}

function MapLegendModal({
  legend,
  legendWarn,
  legendImage,
  mainImageInLegend,
  showHelpModal,
  toggleHelpModal,
}: MapLegendModalProps) {
  return (
    <Modal show={showHelpModal} onHide={toggleHelpModal} size="lg" centered>
      <Modal.Header>
        <h2>Help</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          <b>Description: </b>
          {formatText(legend)}
        </p>
        <p>
          <b>What to check: </b>
          {formatText(legendWarn)}
        </p>
        <div style={{ display: 'flex' }}>
          <div data-cy="map-legend-image" style={{ flex: 1 }}>
            <b>Image </b>
            {mainImageInLegend}
          </div>
          <div data-cy="map-legend-reference-image" style={{ flex: 1 }}>
            <b>Reference image </b>
            {legendImage ?? <p>No reference image available</p>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          data-cy="map-legend-modal-close-button"
          onClick={() => toggleHelpModal()}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MapLegendModal;
